import moment from 'moment'
import Vue from 'vue'
import VueRouter from 'vue-router'
import * as CONST from '../const'
import store from '../store'
import Home from '../views/Home'

Vue.use(VueRouter)

const requireAuth = (to, from, next) => {
  if (store.state.auth.token) {
    next()
  } else {
    next(from.path)
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Главная',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
      ],
    },
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: 'Справка',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'about' }, title: 'Справка' },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About'),
  },
  {
    path: '/contacts',
    name: 'contacts',
    meta: {
      title: 'Обратная связь',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'contacts' }, title: 'Обратная связь' },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (contacts.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "contacts" */ '../views/Contacts'),
  },
  {
    path: '/chart',
    name: 'chart',
    meta: {
      title: 'Все события',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'chart' }, title: 'Все события' },
      ],
    },
    component: () =>
      import(/* webpackChunkName: "chart" */ '../views/Chart'),
  },
  {
    path: '/user_chart',
    name: 'userChart',
    meta: {
      title: 'События пользователей',
      breadcrumbs: ({ route, $store }) => [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'userChart' }, title: 'События пользователей' },
        ...(route.query.user ? [
          {
            to: route,
            title: $store.getters['user/displayName'](Number(route.query.user)),
          },
        ] : []),
      ],
    },
    component: () =>
      import(/* webpackChunkName: "user_chart" */ '../views/UserChart'),
    props: route => {
      const props = {}
      if (route.query.user) {
        const userId = parseInt(route.query.user, 10)
        if (userId && !Number.isNaN(userId)) {
          props.userId = userId
        } else {
          console.error(
            `invalid user param, expected int got "${route.query.user}"`)
        }
      }
      if (route.query.date) {
        const date = moment(route.query.date)
        if (date.isValid()) {
          props.date = date.format('YYYY-MM-DD')
        } else {
          console.error(
            `invalid date param, expected date got "${route.query.date}"`)
        }
      }
      return props
    },
  },
  {
    path: '/feed',
    name: 'feed',
    beforeEnter: requireAuth,
    meta: {
      title: 'Лента событий',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'feed' }, title: 'Лента событий' },
      ],
    },
    component: () =>
      import(/* webpackChunkName: "feed" */ '../views/Feed'),
  },
  {
    path: '/users/',
    name: 'users',
    beforeEnter: requireAuth,
    meta: {
      title: 'Пользователи',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'users' }, title: 'Пользователи' },
      ],
    },
    component: () =>
      import(/* webpackChunkName: "users" */ '../views/Users'),
  },
  {
    path: '/users/:userId',
    name: 'user',
    beforeEnter: requireAuth,
    meta: {
      title: 'Пользователи',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'users' }, title: 'Пользователи' },
        {
          to: ({ route }) => route,
          title: ({ route, $store }) =>
            $store.getters['user/displayName'](Number(route.params.userId)),
        },
      ],
    },
    component: () =>
      import(/* webpackChunkName: "user" */ '../views/User'),
    props: route => ({ userId: Number(route.params.userId) }),
  },
  {
    path: '/integrations',
    name: 'integrations',
    meta: {
      title: 'Интеграция',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'integrations' }, title: 'Интеграция' },
      ],
    },
    component: () =>
      import(/* webpackChunkName: "integrations" */ '../views/Integrations'),
  },
  {
    path: '/settings',
    name: 'settings',
    beforeEnter: requireAuth,
    meta: {
      title: 'Настройки',
      breadcrumbs: [
        { to: { name: 'home' }, title: CONST.APP_NAME },
        { to: { name: 'settings' }, title: 'Настройки' },
      ],
    },
    component: () =>
      import(/* webpackChunkName: "settings" */ '../views/Settings'),
  },
  {
    path: '/-x-auth',
    redirect: { name: 'home' },
  },
]

// редирект на главную при разлогине
store.subscribeAction((action) => {
  if (action.type === 'auth/completeLogOut') {
    router.push({ name: 'home' })
      .catch(e => console.error(e))
  }
})

const router = new VueRouter({
  mode: 'history',
  base: '/',
  fallback: true,
  routes,
})

export default router
